import { Configuration } from 'osep-generator-service-client-v1';
import { Configuration as AuthConfiguration } from 'osep-auth-service-client-v1';
import axios from 'axios';
import { useMsal } from '@azure/msal-react';
import { SilentRequest } from '@azure/msal-browser';
import config from '../config';

const basePath = config.basePath;

export const useApiConfig = () => {
  const { instance, accounts } = useMsal();
  const account = accounts[0];

  const getAccessToken = async () => {
    const silentRequest: SilentRequest = {
      account,
      scopes: [config.apiScope, 'offline_access'],
      authority: config.msalAuthority,
    };

    const response = await instance.acquireTokenSilent(silentRequest);
    return response.accessToken;
  };

  const getApiConfig = async () => {
    const accessToken = `Bearer ${await getAccessToken()}`;

    return new Configuration({
      basePath,
      accessToken,
    });
  };

  const getAuthApiConfig = async () => {
    const accessToken = await getAccessToken();

    return new AuthConfiguration({
      basePath: config.authServiceBasePath,
      accessToken,
    });
  };

  const getUserId = () => account?.localAccountId ?? '';

  return { getApiConfig, getAuthApiConfig, getUserId, axiosInstance: axios };
};
